module.exports = __webpack_public_path__ + "img/images.de5c94a0.svg";